(($, Drupal, drupalSettings) => {
  Drupal.behaviors.officeAutocomplete = {
    attach: (context, settings) => {
      const wrappedAjax = query => {
        return Drupal.ajax({
            url: '/' + settings.path.pathPrefix + 'view_offices/ajax?' + query + '&path=/' + settings.path.pathPrefix + settings.path.currentPath,
          }).execute()
      }
      // Make searchbox usable with enter key.
      $(once('bindsearch', '.autocomplete-offices')).on('keydown', function(e) {
        if (e.keyCode == 13) {
          let suggestionsEl = document.querySelector('.autocomplete-suggestions');
          let AutocompleteEl = document.querySelector('.autocomplete-offices');
          var searchAllowed = false;

          if(document.activeElement === AutocompleteEl) {
            if(suggestionsEl === null || suggestionsEl.style.display === 'none') {
              searchAllowed = true;
            }
            // Make sure autocomplete suggestions aren't actively selected when enter is pressed.
            else {
              var suggestionsActive = false;
              // $(context.querySelectorAll('.autocomplete-suggestion')).once('suggestion').each(function() {
              $(once('suggestion', '.autocomplete-suggestion')).each(function() {
                if($(this).hasClass('selected')) {
                  suggestionsActive = true;
                }
              });
              if(!suggestionsActive) {
                searchAllowed = true;
              }
            }
            if(searchAllowed) {
              makeSearch(context);
            }
          }
        }
      });

      // $(context.querySelectorAll('.autocomplete-wrapper')).once('autocomplete').each(function() {
      $(once('autocomplete', '.autocomplete-wrapper')).each(function() {
        var my_autoComplete;
        $(this).find('.autocomplete-offices').each( (index, item) => {



          // initialize
          my_autoComplete = new autoComplete({
            selector: item,
            source: function(term, suggest){
              try {
                Drupal.behaviors.officeAutocomplete.xhr.abort();
              } catch(e){

              }

              Drupal.behaviors.officeAutocomplete.xhr = $.getJSON('/' + settings.path.pathPrefix + 'autocomplete/office/', {
                q: term,
                office: (item.dataset.office !== undefined ? item.dataset.office : null),
                path: settings.path.currentPath
              }, data => {
                suggest(data)
              });
            },
            renderItem: function (item, search){
              search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
              var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
              return '<div class="autocomplete-suggestion" data-val="'+item.n+'" data-val-uuid="'+item.uuid+'"> '+item.n.replace(re, "<b>$1</b>")+'</div>';
            },
            onSelect: function(e, term, item){

              var valUUID = item.getAttribute('data-val-uuid'), query;
              if (valUUID !== 'null') {
                console.log(item,valUUID)
                query = 'uuid=' + valUUID;
              }
              else {
                query = 'title=' + item.getAttribute('data-val');
              }

              wrappedAjax(query);

              scrollToResults(context);

              if (history.pushState) {
                window.history.pushState({path:''},'','?' + query);
              }
              //alert('Item "'+item.getAttribute('data-val-uuid'));
            }
          });
        });

        $(this).find('.form-submit').click(function() {
          var $e = $(context.querySelectorAll('.autocomplete-offices'));
          var query = $e.val();
          if(query != '') {
            query = 'title='+query;
          }

          wrappedAjax(query);

          scrollToResults(context);

          if (history.pushState) {
            window.history.pushState({path:''},'','?'+query);
          }
        });
      });

      var makeSearch = function(context) {
        var $e = $(context.querySelectorAll('.autocomplete-offices'));
        var query = $e.val();

        if(query != '') {
          query = 'title='+query;
        }

        wrappedAjax(query);

        scrollToResults(context);

        if (history.pushState) {
          window.history.pushState({path:''},'','?'+query);
        }
      }

      var scrollToResults = function(context) {
        var target = $(context.querySelector('.view-id-office_filter_search'));
        if (target.length) {
          var offset = 79;
          $('html,body').stop(true, false).animate({
            scrollTop: target.offset().top - offset
          }, 1000);
          return false;
        }
      }
    },
  }

})(jQuery, Drupal, drupalSettings);
